import {transparentize} from 'polished';

import {greys, greysDark} from '../../styles/colorStyles';

export interface AnnotationSemanticStyles {
  commentAnnotationBackground: string;
  hoverAnnotationBackground: string;
  selectedAnnotationBackground: string;
  focusedAnnotationBackground: string;
  topicAnnotationBorder: string;
  topicAnnotationHoverBackground: string;
  topicAnnotationSelectedBackground: string;
}

export const lightAnnotationSemanticStyles = {
  commentAnnotationBackground: transparentize(0.8, '#FF5C00'),
  hoverAnnotationBackground: transparentize(0.7, '#FF5C00'),
  selectedAnnotationBackground: transparentize(0.6, '#FF5C00'),
  focusedAnnotationBackground: transparentize(1, '#FF5C00'),

  topicAnnotationBorder: greys.shade40,
  topicAnnotationHoverBackground: greys.shade30,
  topicAnnotationSelectedBackground: greys.shade40,
} as const satisfies AnnotationSemanticStyles;

export const darkAnnotationSemanticStyles: AnnotationSemanticStyles = {
  commentAnnotationBackground: transparentize(0.8, '#FF5C00'),
  hoverAnnotationBackground: transparentize(0.7, '#FF5C00'),
  selectedAnnotationBackground: transparentize(0.6, '#FF5C00'),
  focusedAnnotationBackground: transparentize(1, '#FF5C00'),

  topicAnnotationBorder: greysDark.shade60,
  topicAnnotationHoverBackground: greysDark.shade50,
  topicAnnotationSelectedBackground: greysDark.shade60,
} as const satisfies AnnotationSemanticStyles;
